import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DeviceTypeContext} from '../DeviceTypeContext.jsx';
import Deck from '../containers/Deck.js';
import MobileWelcome from '../containers/MobileWelcome.js';
import {getInviteCount, loadInvite, getComponentTypes} from '../lib/tycho';
import {ProgressInfinite} from '@brandwatch/axiom-components';
import {fetchPalette} from '../actions/colors';
import store from '../redux/store';
import './Invite.css';

class Invite extends Component {
  componentDidMount() {
    this.props.getUser();
    loadInvite(this.props.match.params.inviteId);
    store.dispatch(fetchPalette());
    getComponentTypes();
  }

  componentDidUpdate() {
    const {
      invite: {
        deck_id,
        invite_id,
        invitee_id,
        invitee_user_id,
      },
      track
    } = this.props;

    if (!invite_id) {
      return;
    }

    if (!this.hasFetchedInviteCount) {
      this.hasFetchedInviteCount = true;
      getInviteCount(deck_id);
    }

    if (!this.hasTrackedInviteView) {
      this.hasTrackedInviteView = true;
      track('Invite View', {
        deckId: deck_id,
        inviteId: invite_id,
        inviteeId: invitee_id,
        inviteeUserId: invitee_user_id
      });
    }
  }

  render() {
    const {
      invite: {
        deck_id
      },
      isMobileWelcomeAcknowledged,
      location,
      match: {
        params: {
          inviteId
        }
      }
    } = this.props;

    const useMobileView = this.context.isMobile;
    const isLoading = !deck_id;

    let child;

    if (isLoading) {
      child = (
        <ProgressInfinite color='white' />
      );
    } else if (useMobileView && !isMobileWelcomeAcknowledged) {
      child = (
        <MobileWelcome deckId={deck_id} inviteId={inviteId} />
      );
    } else {
      child = (
        <Deck id={deck_id} inviteId={inviteId} location={location} />
      );
    }

    return child;
  }
}

Invite.contextType = DeviceTypeContext;

Invite.propTypes = {
  invite: PropTypes.shape({
    deck_id: PropTypes.number,
    invite_id: PropTypes.string,
    invitee_id: PropTypes.string,
    invitee_user_id: PropTypes.string,
  }),
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  track: PropTypes.func.isRequired,
  getFolderPermissionForUser: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  isMobileWelcomeAcknowledged: PropTypes.bool.isRequired,
};

export default Invite;
